import { useTranslation } from "react-i18next";
import { getAcceptedSentRequestsFilter } from "../../../../../common/queries";
import EntityTable from "../../../../common/tables/EntityTable";
import useMissionRequestsColumns from "../../../../../hooks/useMissionRequestsColumns";
import { useMemo } from "react";
import { useStation } from "../../../../../providers/StationProvider";

export default function AcceptedRequestsSection(props) {
  const { onRowClick } = props;
  const { t } = useTranslation();
  const { station } = useStation();

  const columns = useMissionRequestsColumns(false, null, null, false, true);
  const filter = useMemo(() => getAcceptedSentRequestsFilter(station), [station]);

  return !!station ? (
    <EntityTable
      tableId="accepted_requests_section_sent"
      type="MissionRequest"
      onRowClick={onRowClick}
      columns={columns}
      filter={filter}
      serverSidePaging
      emptyStateTitle={t("missionRequests:acceptedRequestsSection:emptyStateTitle")}
      emptyStateDescription={t("missionRequests:acceptedRequestsSection:emptyStateDescription")}
      sortDescendingByDefault
      xs={12}
    />
  ) : null;
}
